<template>
    <ChangeRevision></ChangeRevision>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const ChangeRevision = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/ChangeRevision.vue"
    )
);

export default {
    name: "Project_HelpChangeRevision", //The name you are in should not equal the name of the component you are importing.
    components: { ChangeRevision, AuthLayout },
};
</script>
